import * as React from 'react';
import { Checkbox } from '@components/atoms';

interface CheckboxHeaderProps {
	checked: boolean;
	onCheckedChange: () => void;
	indeterminate: boolean;
}

export const CheckboxHeader: React.FC<CheckboxHeaderProps> = ({
	checked,
	indeterminate,
	onCheckedChange,
}: CheckboxHeaderProps) => {
	return (
		<Checkbox
			aria-label="Select all"
			checked={checked}
			className="h-4 w-4"
			indeterminate={indeterminate}
			onCheckedChange={onCheckedChange}
		/>
	);
};
